import { EnrichedSwarovskiProductVariant, ProductVariantAvailabilityStatus, VideoType, type EnrichedSwarovskiProductVariantDiscountedPriceFrontend } from "@swo/shared";
import { PdpData } from "../../types";
import { PDPImagesGridImageT } from "../../../PDP_Gallery/types";
import { PDPSwarovskiProductVariantFrontend } from "../../state/types";

export type PDPAvailabilityNotificationsTranslationsProps = Pick<
  PdpData["translations"]["pdp"],
  | "availabilityNotificationLabel.outOfStock"
  | "availabilityNotificationLabel.notYetAvailableForSale"
  | "availabilityNotificationBtnLabel"
  | "emailNotificationLabel"
  | "availabilityNotificationSpamInfoLabel"
  | "yourEmailAddressLabel"
  | "availabilityNotificationIAccept"
  | "privacyPolicyLabel"
  | "thanksForSubscriptionLabel"
  | "youWillBeNotifiedLabel"
  | "closeModalBtnLabel"
  | "unsubscriptionHeadline"
  | "unsubscriptionParagraph"
>;

export type PDPAvailabilityNotificationProductVariantT = {
  availability: ProductVariantAvailabilityStatus;
  image:
    | {
        url: string;
        description: string | undefined;
        sys: {
          id: string;
        };
      }
    | undefined;
  price: EnrichedSwarovskiProductVariant["price"];
  discountedPrice: EnrichedSwarovskiProductVariantDiscountedPriceFrontend;
  name: EnrichedSwarovskiProductVariant["name"];
  sku: EnrichedSwarovskiProductVariant["sku"];
  backInStockNotificationsEnabled: EnrichedSwarovskiProductVariant["backInStockNotificationsEnabled"];
};

export function toPDPAvailabilityNotificationProductVariantT(
  variant: PDPSwarovskiProductVariantFrontend,
  availability: ProductVariantAvailabilityStatus,
  variantPrimaryImage: PDPImagesGridImageT | undefined,
): PDPAvailabilityNotificationProductVariantT {
  const { images, price, discountedPrice, name, sku, backInStockNotificationsEnabled } = variant;

  return {
    availability,
    image: variantPrimaryImage,
    price,
    discountedPrice,
    name,
    sku,
    backInStockNotificationsEnabled,
  };
}
